const IconLinkedIn = (): JSX.Element => {
  return (
    <>
      <path d="M22.2,0H1.8C.83,0,0,.75,0,1.72v20.55c0,.98.83,1.73,1.8,1.73h20.47c.97,0,1.8-.75,1.8-1.72V1.72c-.07-.97-.9-1.72-1.87-1.72ZM3.71,9.11h3.6v11.47h-3.6v-11.47ZM5.51,3.41c1.13,0,2.03.9,2.03,2.1s-.9,2.02-2.03,2.02-2.1-.9-2.1-2.1c.07-1.12.97-2.02,2.1-2.02h0M9.56,9.11h3.38v1.58h.08c.45-.9,1.65-1.88,3.38-1.88,3.6,0,4.27,2.4,4.27,5.48v6.3h-3.53v-5.55c0-1.35,0-3.08-1.88-3.08s-2.17,1.42-2.17,2.92v5.7h-3.52v-11.48h0Z" />
    </>
  );
};

export default IconLinkedIn;
